import { createUseStyles } from 'react-jss'
import { ORANGE, TANGERINE_ORANGE } from '@omnilert/components'

export default createUseStyles({
  alertDescriptionText: {
    marginBottom: ({ hasContacts }) => hasContacts ? '0px' : '15px'
  },
  contactList: {
    margin: '0 !important'
  },
  contactsButtonTitle: {
    fontSize: '18px'
  },
  contactsDisclaimerText: {
    textAlign: 'center',
    marginTop: '15px !important'
  },
  smsDescriptionText: {
    marginTop: '-10px !important',
    marginBottom: '15px !important'
  },
  icon: {
    opacity: 0.6,
    padding: '20px',
    '& path': {
      fill: ({ duration }) => duration ? 'url(#warning)' : 'url(#info)'
    }
  },
  primaryButton: {
    margin: '15px 0'
  },
  primaryButtonTitle: {
    fontSize: '18px'
  },
  responsive: {
    alignItems: 'center',
    backgroundColor: 'var(--secondary__page__background__color)',
    display: 'flex',
    flexDirection: 'column',
    height: '100% !important',
    justifyContent: 'flex-start !important',
    overflowY: 'auto',
    padding: '20px',
    position: 'relative',
    width: '100% !important'
  },
  setTimeButton: {
    '&:hover': {
      color: TANGERINE_ORANGE,
      cursor: 'pointer'
    },
    background: 'transparent',
    border: 'none',
    color: ORANGE,
    fontSize: '18px',
    fontWeight: 'bold',
    textDecoration: 'none',
    userSelect: 'none'
  }
})

